let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("eNmuD"), load("cM9em"), load("fr9NE"), load("3Xgpx")]).then(() => parcelRequire('2NciN'));